import { FixedDimension, PercentDimension } from "../../../../web-graphics";

export function getSizeSettings(sizeText, defaultSizeValue, defaultSizeScale) {
  if (sizeText !== undefined) {
    let sizeTextParts = sizeText.split(" ");
    if (sizeTextParts.length == 2) {
      if (sizeTextParts[1] === "%") {
        return new PercentDimension(parseFloat(sizeTextParts[0], 10) / 100);
      } else if (sizeTextParts[1] === "px") {
        return new FixedDimension(parseFloat(sizeTextParts[0], 10));
      }
    }
  }
  if (defaultSizeScale == 0) {
    return new FixedDimension(defaultSizeValue);
  }
  return new PercentDimension(defaultSizeScale);
}
